import { Fragment, FunctionComponent } from "react";

import Typography from "components/common/ui/Typography/Typography";
import useBreakpoints from "hooks/useBreakpoints";
import { HelperText } from "../PasswordReset.Styled";
import ResetPasswordForm from "./ResetPasswordForm";
import { useTranslation } from "react-i18next";

const ResetPassword: FunctionComponent = () => {
	const { large } = useBreakpoints();
	const { t } = useTranslation();

	return (
		<Fragment>
			<Typography variant="heading" size="small">
				{t("changePassword")}
			</Typography>
			<HelperText>
				<Typography variant="body" size="small">
					{t("form.validation.password.alpha_num")}
				</Typography>
			</HelperText>

			<ResetPasswordForm large={large} />
		</Fragment>
	);
};

export default ResetPassword;
